<template>
  <div class="w-full flex flex-row justify-center card-gallery-main-container font-rubik">
    <section class="w-full max-w-1024 card-gallery-inner-container mx-5">
      <div class="container">
        <div class="header">
          <p class="tagline">{{ tagline }}</p>
          <h1 class="main-heading">{{ heading }}</h1>
          <p class="description">{{ description }}</p>
        </div>
        <div class="feature-container">
          <FeatureCard
            v-for="(feature, index) in features"
            :key="index"
            :is-active="activeIndex === index"
            @mouseenter.native="handleMouseEnter(index)"
            @mouseleave.native="handleMouseLeave"
            :feature="feature"
            :label-background-color="cardLabelBackgroundColor"
            :label-text-color="cardLabelTextColor"
            :feature-content-background-color="featureContentBackgroundColor"
            :feature-content-text-color="featureContentTextColor"
            :page="page"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FeatureCard from './helpers/feature-card.vue'

export default {
  components: {
    FeatureCard
  },
  props: {
    page: {
      type: String,
      required: true
    },
    cardLabelBackgroundColor: {
      type: String,
      default: '#A020F0'
    },
    cardLabelTextColor: {
      type: String
    },
    featureContentBackgroundColor: {
      type: String
    },
    featureContentTextColor: {
      type: String
    },
    tagline: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      interval: null,
      isMouseOverCard: false
    }
  },
  methods: {
    handleSetIsActive(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    },
    startAutoCollapseExpand() {
      this.interval = setInterval(() => {
        if (!this.isMouseOverCard) {
          // Cycle through the cards automatically
          this.activeIndex = (this.activeIndex + 1) % this.features.length
        }
      }, 8000)
    },
    handleMouseEnter(index) {
      this.isMouseOverCard = true
      this.activeIndex = index
    },
    handleMouseLeave() {
      this.isMouseOverCard = false
    }
  },
  mounted() {
    this.startAutoCollapseExpand()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
.card-gallery-main-container {
  background-color: #0C0E20;
}

.container {
  min-width: 100%;
  margin: 0 auto;
}

.tagline {
  margin-bottom: 16px;
  font-weight: 600;
}

.main-heading {
  font-size: 48px;
  font-weight: bold;
}

.description {
  font-size: 1rem;
}

.feature-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: auto;
}

.card-gallery-inner-container {
  padding: 24px 0px;
}

/* Desktop */
@media (min-width: 1024px) {
  .card-gallery-inner-container {
    padding-top: 56px;
    padding-bottom: 112px;
  }

  .feature-container {
    flex-direction: row;
    gap: 10px;
    height: 720px;
  }

  .header .main-heading {
    font-size: 64px;
  }
}
</style>
